import Button from "react-bootstrap/Button";
import './App.css';
import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useState } from "react";

export function SignUp() {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://5zc1rg97rl.execute-api.us-east-1.amazonaws.com/signup",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        alert("Thank you for subscribing!");
        setFormData({ name: "", email: "" });
      } else {
        alert(result.message || "Something went wrong");
      }

    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Network error. Please try again.");
    }
  };

  return (
    <div>
      <Container>
        <Row>
          <Col xs={2} md={2} lg={3} xl={4}></Col>

          <div className="header">
            <h2>Subscribe to our Newsletter</h2>
            <p>Receive Weekly Updates and Exclusive Coupons!</p>
          </div>

          <Col xs={2} md={2} lg={3} xl={4}></Col>
        </Row>
      </Container>

      <Container>
        <Row>
          <Col xs={2} md={2} lg={3} xl={4}></Col>

          <div>
            <form onSubmit={handleSubmit}>
              
              <div className="form-group">
                <label className="formlabel" htmlFor="name">Name: </label>

                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label className="formlabel" htmlFor="email">Email: </label>

                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <Button variant="primary" type="submit">
                Subscribe
              </Button>

            </form>
          </div>

          <Col xs={2} md={2} lg={3} xl={4}></Col>
        </Row>
      </Container>
    </div>
  );
}